import type { AccordionPanel } from '@modules/search/components/filter-drawer/FilterAccordion';

// Function to determine default active panels based on URL
export const getDefaultActivePanels = (): number => {
    if (typeof window !== 'undefined') {
        const url = window.location.pathname;
        // Check for both '/products' and '/products/' to handle cases with and without trailing slash
        // This matches '/products' exactly or '/products/' followed by anything
        return url === '/products' || url.startsWith('/products/') ? 0 : 3;
    }
    return 0; // Default fallback for SSR
};

/**
 * Get the default keys of panels to show as open.
 * Not intended for mobile.
 * For more info see: https://archipro.atlassian.net/browse/GROW-3675
 *
 * @param panels
 *      - Panel array to extract keys from
 * @param activePanelsShown
 *      - The amount of panels you want to show
 *      - Defaults to 0 for product pages, 3 for other pages
 * @returns
 *      - An array of keys for the given panels
 */

export const getInitialActivePanelsKeys = (
    panels: AccordionPanel[],
    activePanelsShown?: number,
) => {
    const defaultActivePanels = activePanelsShown ?? getDefaultActivePanels();
    return panels.slice(0, defaultActivePanels).map((panel) => panel.title.key);
};
